import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import { Root } from './Root'

import './Language/i18n'

import { initializeTelemetryService } from 'src/telemetryService'
import { initTelemetryMetrics } from 'src/Tracking/initTelemetryMetrics'
import { isDarkMode, optInForDS } from 'src/Utils/designSystem'

const loadStylesheet = async () => {
  if (!optInForDS()) {
    await import('src/rootAlt.css')
  } else if (isDarkMode()) {
    await import('src/root-dark.scss')
  } else {
    await import('src/root.scss')
  }
}

window.setTimeout(() => {
  initializeTelemetryService()
  initTelemetryMetrics()
})

const container = document.getElementById('root')!
const root = createRoot(container)

loadStylesheet().then(() => {
  root.render(
    <StrictMode>
      <Root />
    </StrictMode>
  )
})
